export const statusColors = {
  // Auto.
  "Qualified - Offer": "greenWhiteText",
  "Qualified - Multi-threaded": "greenWhiteText",
  "Qualified - Close to Finish": "greenWhiteText",
  "Need to Multi-thread": "darkRedWhiteText",
  "Company-Pinged": "yellowWhiteText",
  New: "blueWhiteText",
  // Manual.
  Evergreen: "greenDarkText",
  Hold: "lightOrangeDarkText",
  Backfill: "greenDarkText",
  "No Backfill": "redWhiteText",
  "Waiting to Hear": "yellowDarkText",
  "Hired - Partner": "greenDarkText",
  "Hired - Non-Partner": "greenDarkText",
  "Red Flag": "lightRedDarkText",
  Unsubscribed: "redDarkText",
  Exclude: "redDarkText",
  "Top 5": "purpleDarkText",
  "CS Sprint": "tealDarkText",
  "Tier 1": "tier1DarkText",
  "Tier 2": "tier2DarkText",
  "Tier 3": "tier3DarkText",
  Ready: "greenWhiteText",
  "Not Ready": "lightRedDarkText",
};

export const interviewStatusColors = {
  New: "greenWhiteText",
  "Heavily Recruited": "heavilyRecruited",
  Interviewing: "interviewing",
  "Early in Search": "earlyInSearch",
};

export function getStatusColor(statusName: string) {
  if (isValidStatus(statusName)) {
    return DS_STATUS_COLORS[statusName];
  }

  return { colorScheme: "neutral", variant: "subtle" } as const;
}

function isValidStatus(statusName: string): statusName is keyof typeof DS_STATUS_COLORS {
  return statusName in DS_STATUS_COLORS;
}

export const DS_STATUS_COLORS = {
  // Auto statuses
  "Qualified - Offer": { colorScheme: "green", variant: "solid" },
  "Qualified - Multi-threaded": { colorScheme: "green", variant: "solid" },
  "Qualified - Close to Finish": { colorScheme: "green", variant: "solid" },
  "Need to Multi-thread": { colorScheme: "red", variant: "solid" },
  "Company-Pinged": { colorScheme: "yellow", variant: "solid" },
  New: { colorScheme: "blue", variant: "solid" },
  // Manual statuses
  Evergreen: { colorScheme: "green", variant: "subtle" },
  Hold: { colorScheme: "orange", variant: "subtle" },
  Backfill: { colorScheme: "green", variant: "subtle" },
  "No Backfill": { colorScheme: "red", variant: "solid" },
  "Waiting to Hear": { colorScheme: "yellow", variant: "subtle" },
  "Hired - Partner": { colorScheme: "green", variant: "subtle" },
  "Hired - Non-Partner": { colorScheme: "green", variant: "subtle" },
  "Red Flag": { colorScheme: "red", variant: "subtle" },
  "Green Flag": { colorScheme: "green", variant: "subtle" },
  Unsubscribed: { colorScheme: "red", variant: "subtle" },
  Exclude: { colorScheme: "red", variant: "subtle" },
  "Top 5": { colorScheme: "purple", variant: "subtle" },
  "CS Sprint": { colorScheme: "teal", variant: "subtle" },
  "Tier 1": { colorScheme: "blue", variant: "subtle" },
  "Tier 2": { colorScheme: "teal", variant: "subtle" },
  "Tier 3": { colorScheme: "neutral", variant: "subtle" },
  Ready: { colorScheme: "green", variant: "solid" },
  "Not Ready": { colorScheme: "red", variant: "subtle" },
} as const;
